import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as ExcelJS from 'exceljs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';

@Component({
  selector: 'app-excel-handler',
  standalone: true,
  templateUrl: './excel-handler.component.html',
  styleUrls: ['./excel-handler.component.scss'],
  imports: [CommonModule, FormsModule, AgGridModule]
})
export class ExcelHandlerComponent implements OnInit {
  @Input() fileUrl: string = '';
  @Output() dataLoaded = new EventEmitter<any>();
  data: any[] = [];
  headData: any;
  isError: boolean;
  isLoading: boolean;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchExcelFromUrl(this.fileUrl);
  }

  fetchExcelFromUrl(url: string): void {
    console.log(url);
    if (!url) {
      alert('Please provide a valid URL');
      return;
    }

    this.http.get(url, { responseType: 'arraybuffer' }).subscribe({
      next: async (response: ArrayBuffer) => {
        try {
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(response);

          const worksheet = workbook.worksheets[0];
          this.data = [];
          this.headData = [];

          worksheet.getRow(3).eachCell((cell, colNumber) => {
            this.headData.push({
              field: `Column${colNumber}`,
              headerName: cell.value,
              sortable: true,
              filter: true,
            });
          });

          worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 3) {
              const rowData: any = {};
              row.eachCell((cell, colNumber) => {
                rowData[`Column${colNumber}`] = cell.value;
              });
              this.data.push(rowData);
            }
          });

          this.dataLoaded.emit(this.data);
        } catch (error) {
          console.error('Error parsing Excel file:', error);
          this.isError = true;
        } finally {
          this.isLoading = false;
        }
      },
      error: (err) => {
        console.error('Error fetching the Excel file:', err);
        this.isError = true;
        this.isLoading = false;
      }
    });
  }
}
